import { customTextFieldStyle } from "components/CustomTextField/CustomTextField.style";

export const consumingTextFieldStyle = { ...customTextFieldStyle };
